
import Framework from '@geek/yum-freight-framework'
import router from '@geek/yum-freight-framework/src/router'
import YunIcon from '@yld/yun-icon'
import './assets/element.scss'
import Vue from 'vue'
import {
  ensureSpotIframeMessageListener,
  ensureEcomRatesTagCloseReset,
  ensureEcomRatesKeepAlive
} from '@/utils/spotIframeMessage'
import { ensureDocumentTitle } from '@/utils/documentTitle'

const serverConfig = require('../serverConfig.json')

Vue.prototype.$eventBus = new Vue()
const app = new Framework({
  serverConfig
})

app.use(YunIcon)

// 需在 start 前注册，否则首次进入电商运价拿不到 keepAlive
ensureEcomRatesKeepAlive(router)
// 浏览器标题跟随当前菜单路径（框架默认对本应用固定显示 CRM）
ensureDocumentTitle(router, serverConfig.title)

app.start()

ensureSpotIframeMessageListener({
  $router: router,
  $appId: serverConfig.appId
})
ensureEcomRatesTagCloseReset()
